import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#F2EDE4] text-[#1C1C1C]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-14">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/35dfbba8-161b-4e9d-b2b4-7573528d9085/0b4f8e8c-c037-4109-aa87-6a47ee07b13a_make-it-a-magazine-logo.svg?v=7cf42213bf0458068400099fa4dab89f"
              alt="Make It A Magazine"
              className="h-14 w-auto object-contain mb-5"
            />
            <p className="text-[#6A6A6A] text-sm leading-relaxed">
              We turn creator content into gorgeous physical magazines — distributed to real people who love what you make.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-xs tracking-widest uppercase text-[#C41E3A] font-semibold mb-5">Navigation</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "About", path: "/about" },
                { label: "Creators", path: "/creators" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-[#4A4A4A] text-sm hover:text-[#C41E3A] transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For Creators */}
          <div>
            <p className="text-xs tracking-widest uppercase text-[#C41E3A] font-semibold mb-5">For Creators</p>
            <ul className="flex flex-col gap-3">
              {["How It Works", "Distribution Plans", "Pricing", "Creator FAQ", "Submit Content"].map((item) => (
                <li key={item}>
                  <Link to="/contact" className="text-[#4A4A4A] text-sm hover:text-[#C41E3A] transition-colors cursor-pointer">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <p className="text-xs tracking-widest uppercase text-[#C41E3A] font-semibold mb-5">Connect</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "Instagram", icon: "ri-instagram-line" },
                { label: "Twitter / X", icon: "ri-twitter-x-line" },
                { label: "LinkedIn", icon: "ri-linkedin-line" },
                { label: "Pinterest", icon: "ri-pinterest-line" },
              ].map((s) => (
                <li key={s.label}>
                  <a href="#" className="flex items-center gap-2 text-[#4A4A4A] text-sm hover:text-[#C41E3A] transition-colors cursor-pointer">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={s.icon} />
                    </span>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#E0DAD0] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#9A9A9A] text-xs tracking-widest uppercase">
            &copy; {new Date().getFullYear()} The Magazine Co. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#9A9A9A] text-xs hover:text-[#C41E3A] transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-[#9A9A9A] text-xs hover:text-[#C41E3A] transition-colors cursor-pointer">Terms of Service</a>
            <a
              href="/sitemap.xml"
              target="_blank"
              rel="nofollow noopener"
              className="text-[#9A9A9A] text-xs hover:text-[#C41E3A] transition-colors cursor-pointer"
            >
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
